import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  readCommentsApiEndpoint,
  readUrnFromMetaTag,
} from '@fec/assets/js/utils/meta-tags';

import { AppContextProvider } from '@Comments/context/AppContext';
import { BusinessUnit } from '@Comments/models/BusinessUnit';
import { App } from '@Comments/App';
import { LoginProvider } from '@Comments/models/LoginProvider';

export function init(commentsCount: number) {
  const commentsRoot = document.getElementById('srf-comments');
  const env = {
    bu: 'srf' as BusinessUnit,
    base: readCommentsApiEndpoint(),
    threadUrn: readUrnFromMetaTag(),
    loginProvider: (commentsRoot?.dataset.loginProvider ??
      'janrain') as LoginProvider,
  };

  if (commentsRoot) {
    commentsRoot.classList.remove('h-element--hide');
    const root = createRoot(commentsRoot!);
    root.render(
      <React.StrictMode>
        <AppContextProvider value={{ env, commentsCount }}>
          <App />
        </AppContextProvider>
      </React.StrictMode>,
    );
  }
}
